import styled from "@emotion/styled"
import Typography from "@mui/material/Typography"
import { Link } from "utils"
import { breakpoints } from "../../theme/mediaQueries"
import { sizes } from "../../theme/sizes"
import { colors } from "../../theme/colors"

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${sizes.spacing[16]}px;
`

export const Panel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${sizes.spacing[24]}px;
  width: 100%;
  max-width: 432px;
  background: ${colors.primitives.neutral0};
  border-radius: ${sizes.borderRadius[24]}px;
  padding: ${sizes.spacing[24]}px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  max-height: calc(100vh - ${sizes.spacing[32]}px);
  overflow-y: auto;
`

export const CloseButton = styled.button`
  position: absolute;
  top: ${sizes.spacing[24]}px;
  inset-inline-start: ${sizes.spacing[24]}px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: ${colors.primitives.neutral600};
  transition: background-color 0.2s;

  svg {
    width: 24px;
    height: 24px;
  }

  /* EGDE-499: hover puts the X on a gray disc (Figma ref #F1F1F1) — the icon
     itself stays dark at full opacity. */
  &:hover {
    background-color: ${colors.primitives.neutral200};
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizes.spacing[16]}px;
`

export const LogoImage = styled.img`
  width: 64px;
  height: 64px;
  object-fit: contain;

  @media (min-width: ${breakpoints.lg}px) {
    width: 80px;
    height: 80px;
  }
`

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizes.spacing[8]}px;
  width: 100%;

  @media (min-width: ${breakpoints.lg}px) {
    gap: ${sizes.spacing[4]}px;
  }
`

export const Title = styled(Typography)`
  text-align: center;
  font-weight: 700;
  letter-spacing: 0.15px;
`

export const Subtitle = styled(Typography)`
  text-align: center;
  letter-spacing: 0.15px;
  /* Figma "Dark Blue - Texts" (#00182B) — no theme token exists for this value */
  color: #00182b;
`

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.spacing[16]}px;
  width: 100%;
`

export const ChannelCard = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${sizes.spacing[12]}px;
  width: 100%;
  padding: ${sizes.spacing[16]}px;
  background: ${colors.primitives.neutral0};
  border: 1px solid ${colors.primitives.neutral300};
  border-radius: ${sizes.borderRadius[16]}px;
  text-decoration: none;
  color: ${colors.light.text.primary};
  cursor: pointer;
  transition:
    border-color 0.2s,
    background 0.2s;

  /* EGDE-499: Figma hover = the card border turns dark on a white card (no
     gray wash). The inset shadow doubles the 1px border to the 2px weight of
     the design without shifting layout. */
  &:hover {
    border-color: ${colors.primitives.neutral600};
    box-shadow: inset 0 0 0 1px ${colors.primitives.neutral600};
    background: ${colors.primitives.neutral0};
  }
`

export const ChannelLabel = styled(Typography)`
  flex: 1;
  text-align: start;
`
